module.exports = __webpack_public_path__ + "static/arquivo-7da6b93c15b036cd3134b5c03a7436cf.jpeg";